import { styled } from 'theme';

const FormLabel = styled('label', {
  // Reset
  boxSizing: 'border-box',
  lineHeight: '$none',

  // Custom
  display: 'block',
  mb: '$2',
  fontSize: '$sm',
  letterSpacing: '$wide',
  color: '$primary',
});

export default FormLabel;
